import { Table, Badge } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const tableData = [
  {
    site: "03",
    subject: "03-006",
    screening: "SCR-03006",
    rand: "R-3155",
    status: "Ongoing",
    total: 13,
    open: 2,
    answered: 1,
    closed: 10,
    overdue: 2,
    reopened: 1,
    oldestOpen: "143 d",
    formsOpen: 3,
    visitsOpen: 3,
    sdv: "Verified",
    freezeLock: "Frozen",
  },
  {
    site: "02",
    subject: "02-015",
    screening: "SCR-02015",
    rand: "R-7782",
    status: "Completed",
    total: 12,
    open: 2,
    answered: 4,
    closed: 5,
    overdue: 5,
    reopened: 0,
    oldestOpen: "99 d",
    formsOpen: 5,
    visitsOpen: 5,
    sdv: "Verified",
    freezeLock: "-",
  },
  {
    site: "06",
    subject: "06-003",
    screening: "SCR-06003",
    rand: "R-8075",
    status: "Ongoing",
    total: 12,
    open: 2,
    answered: 1,
    closed: 8,
    overdue: 1,
    reopened: 2,
    oldestOpen: "48 d",
    formsOpen: 3,
    visitsOpen: 3,
    sdv: "Verified",
    freezeLock: "Locked",
  },
  {
    site: "01",
    subject: "01-018",
    screening: "SCR-01018",
    rand: "R-1047",
    status: "Discontinued",
    total: 12,
    open: 2,
    answered: 1,
    closed: 8,
    overdue: 2,
    reopened: 0,
    oldestOpen: "26 d",
    formsOpen: 3,
    visitsOpen: 3,
    sdv: "Verified",
    freezeLock: "-",
  },
  {
    site: "01",
    subject: "01-008",
    screening: "SCR-01008",
    rand: "R-3911",
    status: "Ongoing",
    total: 11,
    open: 2,
    answered: 3,
    closed: 6,
    overdue: 5,
    reopened: 0,
    oldestOpen: "55 d",
    formsOpen: 3,
    visitsOpen: 5,
    sdv: "Pending",
    freezeLock: "Frozen",
  },
];

const SubjectWiseQuerySummaryTable = ({
  userActivityLoader,
}) => {
  const getSDVBadge = (status) => {
    switch (status) {
      case "Verified":
        return <Badge bg="success-subtle" text="success">{status}</Badge>;
      case "Pending":
        return <Badge bg="warning-subtle" text="warning">{status}</Badge>;
      case "Partially verified":
        return <Badge bg="warning-subtle" text="dark">{status}</Badge>;
      default:
        return status;
    }
  };

  return (
    <>
      {userActivityLoader ? (
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader />
        </div>
      ) : (
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>SITE</th>
              <th>SUBJECT</th>
              <th>SCREENING #</th>
              <th>RAND #</th>
              <th>STATUS</th>
              <th>TOTAL</th>
              <th>OPEN</th>
              <th>ANSWERED</th>
              <th>CLOSED</th>
              <th>OVERDUE</th>
              <th>RE-OPENED</th>
              <th>OLDEST OPEN</th>
              <th>FORMS W/ OPEN</th>
              <th>VISITS W/ OPEN</th>
              <th>SDV</th>
              <th>FREEZE/LOCK</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td>{row.site}</td>
                <td>
                  <a href="#" className="fw-semibold text-decoration-none">
                    {row.subject}
                  </a>
                </td>
                <td>{row.screening}</td>
                <td>{row.rand}</td>
                <td>{row.status}</td>
                <td>{row.total}</td>
                <td className="text-primary fw-semibold">{row.open}</td>
                <td>{row.answered}</td>
                <td>{row.closed}</td>
                <td className="text-danger fw-semibold">{row.overdue}</td>
                <td>{row.reopened}</td>
                <td>{row.oldestOpen}</td>
                <td>{row.formsOpen}</td>
                <td>{row.visitsOpen}</td>
                <td>{getSDVBadge(row.sdv)}</td>
                <td>{row.freezeLock}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default SubjectWiseQuerySummaryTable;